import React, { memo } from "react";
import { FilterGroup as FilterGroupType } from "./types";
import { FilterInput } from "./FilterInput";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/Accordion";

export const FilterGroup = memo(function FilterGroup({
  group,
}: {
  group: FilterGroupType;
}) {
  return (
    <AccordionItem
      value={group.title}
      className="px-2 last:border-0"
      data-testid="filter-group"
    >
      <div className="py-2">
        <AccordionTrigger className="px-2 py-2 leading-5 font-bold text-primary-light/80 uppercase">
          {group.title}
        </AccordionTrigger>
      </div>
      <AccordionContent
        data-testid="filter-group-content"
        className="px-2 pb-2"
      >
        {group.filters.map((filter) => {
          return <FilterInput key={filter.name} filter={filter} />;
        })}
      </AccordionContent>
    </AccordionItem>
  );
});
